<template>
  <transition-group
      name="list"
      mode="out-in"
      tag="div"
      class="w-100">
    <div
        v-for="(notifications, index) in groupedNotifications"
        :key="index">
      <h2 class="p-1 GROUP-TITLE" :selenium="`notification-day:${index+1}`">
        {{ formatedDate(new Date(notifications[0].created_dtm)) }}
      </h2>
      <div class="bg-white GROUPED-ITEMS">
        <notification-item
            v-for="(notification, order) in notifications"
            :key="notification.id"
            :notification="notification"
            tabindex="0"
            class="cur-pointer"
            :selenium="`notification-item:${index+1}:${order+1}`"
            @keypress.native.enter="$emit('notificationClick', notification.id)"
            @click.native="$emit('notificationClick', notification.id)"/>
      </div>
    </div>
    <div v-if="meta.hasMore" selenium="more-items" key="loading">
      <job-item-ghost v-for="n in 2" :key="n" class="bd-transparent"/>
    </div>
    <template v-else>
      <notification-item
          v-for="notification in $options.STATIC_NOTIFICATIONS"
          :key="notification.data.summary"
          :notification="notification"
          class="select-none bg-white SINGLE-ITEM"
          selenium="notifications-empty"/>
    </template>
  </transition-group>
</template>

<script>
import JobItemGhost from './JobItemGhost';
import NotificationItem from './NotificationItem';

const STATIC_NOTIFICATIONS = [
  {
    read: true,
    data: {
      summary: 'Welcome to the new notifications',
      content: 'The updated notifications screen lets you track job updates, view account reminders and recent activity in one convenient place',
    },
  },
];
export default {
  name: 'notification-list',
  STATIC_NOTIFICATIONS,
  components: {
    JobItemGhost,
    NotificationItem,
  },
  props: {
    groupedNotifications: {
      type: Array,
      default () { return []; },
    },
    meta: {
      type: Object,
      default () { return {}; },
    },
  },
  methods: {
    formatedDate (date) {
      return `${date.toLocaleString('default', { month: 'long' })}, ${date.getFullYear()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.NOTIFICATION-HEADER {
  @include padding(2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  border-bottom: 1px solid $color-gray30;
}

.GROUPED-ITEMS {
  border: 1px solid $color-gray40;
}

.SINGLE-ITEM{
  border: 1px solid $color-gray40;
  margin-bottom: 20px;
}

.GROUP-TITLE {
  position: relative;
  overflow: hidden;
  &:after {
    position: absolute;
    top:50%;
    content: '';
    width: 100%;
    height: 2px;
    margin-left: 10px;
    background-color: $color-gray50;
  }
}
</style>
